// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hD13m","buttons":"styles_buttons__3CQf6"};